import { render } from "@projectComps/ProjectsTable/ProjectsTable.html?vue&type=template&id=69b21a92&external"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "@projectComps/ProjectsTable/ProjectsTable.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__